'use client';

import React from 'react';

import { X } from 'lucide-react';

import { Drawer, DrawerContent, DrawerHeader } from '../ui/drawer';
import { Button } from '@nextui-org/react';

interface IBottomDrawerProps {
  visible: boolean;
  close: () => void;
  title?: string;
  children: React.ReactNode;
  showCloseButton?: boolean;
}

export const BottomDrawer = ({
  children,
  visible,
  close,
  title,
  showCloseButton = false,
}: IBottomDrawerProps) => {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Drawer
        open={visible}
        onOpenChange={(open) => {
          if (!open) close();
        }}
      >
        {/*<DrawerTrigger asChild>*/}
        {/*  <Button variant="outline">Open Drawer</Button>*/}
        {/*</DrawerTrigger>*/}
        <DrawerContent>
          {showCloseButton && (
            <div className="absolute  top-1 right-1">
              <Button onClick={close} isIconOnly variant="light">
                <X className="text-gray-500" />
              </Button>
            </div>
          )}
          {title && (
            <DrawerHeader className="shrink-0 text-2xl  font-bold">
              <h2>{title}</h2>
            </DrawerHeader>
          )}
          <div className="min-h-0 flex-1 touch-pan-y overflow-y-auto overscroll-contain [-webkit-overflow-scrolling:touch] px-4 pb-8">
            {children}
          </div>
          {/*<DrawerFooter>*/}
          {/*  <Button>Submit</Button>*/}
          {/*</DrawerFooter>*/}
        </DrawerContent>
      </Drawer>
    </div>
  );
};
